import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Handshake, Compass, TrendingUp, Sparkles } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { HERO_IMAGES } from '../data/mock';
import Reveal from '../components/Reveal';

const Expertise = () => {
  const { t } = useLang();

  const services = [
    { icon: Handshake, t: t('expertise.e1t'), d: t('expertise.e1d') },
    { icon: Compass, t: t('expertise.e2t'), d: t('expertise.e2d') },
    { icon: TrendingUp, t: t('expertise.e3t'), d: t('expertise.e3d') },
    { icon: Sparkles, t: t('expertise.e4t'), d: t('expertise.e4d') },
  ];

  const steps = [
    { n: '01', t: t('expertise.p1t'), d: t('expertise.p1d') },
    { n: '02', t: t('expertise.p2t'), d: t('expertise.p2d') },
    { n: '03', t: t('expertise.p3t'), d: t('expertise.p3d') },
    { n: '04', t: t('expertise.p4t'), d: t('expertise.p4d') },
  ];

  return (
    <div className="bg-[#f4efe6]">
      {/* banner */}
      <section className="relative pt-40 pb-20 md:pt-48 md:pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO_IMAGES.parisGolden2} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1b2331]/72" />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="font-sans-elegant text-[0.7rem] tracking-brand text-[#c8a469] mb-5">STARKKE IMMOBILIER</p>
          <h1 className="font-serif-display text-4xl md:text-6xl text-[#f4efe6] font-light leading-tight">{t('expertise.title')}</h1>
          <p className="font-sans-elegant text-[#f4efe6]/70 max-w-xl mt-5 leading-relaxed">{t('expertise.subtitle')}</p>
        </div>
      </section>

      {/* services */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16">
            {services.map((s, i) => (
              <Reveal key={i} delay={(i % 2) * 120}>
                <div className="flex gap-6">
                  <div className="shrink-0">
                    <div className="w-14 h-14 border border-[#b0894f] flex items-center justify-center">
                      <s.icon className="w-6 h-6 text-[#b0894f]" strokeWidth={1.4} />
                    </div>
                  </div>
                  <div>
                    <span className="font-serif-display text-lg text-[#b0894f]">0{i + 1}</span>
                    <h3 className="font-serif-display text-3xl text-[#1b2331] mt-1 mb-4 leading-tight">{s.t}</h3>
                    <p className="font-sans-elegant text-[#5a5d63] leading-relaxed">{s.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* method */}
      <section className="py-24 md:py-32 bg-[#1b2331]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal>
            <h2 className="font-serif-display text-3xl md:text-5xl text-[#f4efe6] font-light leading-tight mb-16 max-w-xl">
              {t('expertise.processTitle')}
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            {steps.map((s, i) => (
              <Reveal key={i} delay={i * 100}>
                <div className="border-t border-[#f4efe6]/20 pt-6">
                  <span className="font-serif-display text-4xl text-[#c8a469]">{s.n}</span>
                  <h3 className="font-serif-display text-2xl text-[#f4efe6] mt-4 mb-3">{s.t}</h3>
                  <p className="font-sans-elegant text-sm text-[#f4efe6]/60 leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* cta */}
      <section className="py-24 md:py-28 bg-[#eae2d3]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-8">
          <h2 className="font-serif-display text-3xl md:text-4xl text-[#1b2331] font-light leading-tight max-w-lg">
            {t('cta.title')}
          </h2>
          <Link
            to="/contact"
            className="group inline-flex items-center gap-3 bg-[#1b2331] text-[#f4efe6] font-sans-elegant text-xs tracking-wide-2 uppercase px-10 py-4 hover:bg-[#b0894f] transition-colors shrink-0"
          >
            {t('cta.button')}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Expertise;
